import eventstop from 'eventstop'

export default eventstop()



// WEBPACK FOOTER //
// ./src/utils/event.js